var React = require('react');

function Pl (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11","fill":"white","key":0}),React.createElement("path",{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#F0F0F0","key":1}),React.createElement("path",{"d":"M22 12C22 17.5228 17.5228 22 12 22C6.47719 22 2 17.5228 2 12","fill":"#D80027","key":2})]);
}

Pl.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Pl;

Pl.default = Pl;
